import preferences from './preferences/text.js';

export default {
  preferences,
  action: {
    openPreferences: {
      notes: 'Open preferences dialog',
      message: 'Preferences',
    },
    openAccountSelection: {
      notes: 'Open account selection dialog',
      message: 'Switch to customer',
    },
    logout: {
      notes: 'Logout action',
      message: 'Log out',
    },
    changePassword: {
      notes: 'Change password action',
      message: 'Change password',
    },
  },
  theme: {
    header: {
      notes: 'Menu subheader for theme',
      message: 'Theme',
    },
    light: {
      notes: 'Light theme',
      message: 'Light',
    },
    dark: {
      notes: 'Dark theme',
      message: 'Dark',
    },
    automatic: {
      notes: 'Automatic theme (inherit setting from browser / os)',
      message: 'Automatic',
    },
  },
  units: {
    header: {
      notes: 'Menu subheader for units',
      message: 'Units',
    },
    metric: {
      notes: 'Metric units',
      message: 'Metric',
    },
    us: {
      notes: 'US units',
      message: 'US Customary',
    },
  },
};
